import type { ButtonHTMLAttributes } from 'react';
import type { LucideIcon } from 'lucide-react';
import styles from './ui.module.css';

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: LucideIcon;
  label: string;
  active?: boolean;
  size?: number;
}

export function IconButton({
  icon: Icon,
  label,
  active = false,
  size = 16,
  ...props
}: IconButtonProps) {
  return (
    <button
      type="button"
      className={styles.iconButton}
      aria-label={label}
      title={label}
      data-active={active}
      {...props}
    >
      <Icon size={size} strokeWidth={1.8} aria-hidden="true" />
    </button>
  );
}
